import React, { Component } from 'react';
import './style.scss';

class Footer extends Component {
    public render() {
        return (
            <div className="disclosure-footer">
                <p
                    dangerouslySetInnerHTML={{
                        __html: __(
                            'TradeUP Securities, Inc. is a member of <a href="https://www.finra.org/#/" target="_blank">FINRA</a>, <a href="https://www.sipc.org/" target="_blank">SIPC</a>, and <a href="https://www.nyse.com/index" target="_blank">NYSE</a>, 437 Madison Ave, 27th Floor, New York, NY 10022. For further information about TradeUP Securities, Inc., see <a href="https://brokercheck.finra.org/" target="_blank">FINRA BrokerCheck.</a>'
                        )
                    }}
                />

                <p>
                    {__(
                        'All investments involve risk, including possible loss of principal. The past performance of a security, market, or financial product does not guarantee future results. Electronic trading poses unique risk to investors. System response and access times may vary due to market conditions, system performance, and other factors. Market volatility, volume, and system availability may delay account access and trade executions.'
                    )}
                </p>

                <p
                    dangerouslySetInnerHTML={{
                        __html: __(
                            '$0.00 commission applies to online U.S. equity trades and exchange-traded funds (ETFs) in a TradeUP retail account only for TradeUP Securities, Inc. retail clients. Sell orders are subject to an activity assessment fee. Other exclusions and conditions may apply. See <a href="https://www.tradeup.com/pricing/commissions-us" target="_blank">https://www.tradeup.com/pricing/commissions-us</a> for details. Institutional accounts, OTC securities trading and other types of high-touch services are subject to different commission schedules.'
                        )
                    }}
                />

                <p
                    dangerouslySetInnerHTML={{
                        __html: __(
                            'Margin may not be suitable for all investors due to the risks associated with using leverage. Please review the <a href="https://www.marsco.com/static/pdf/MARGIN-DISCLOSURE-STATEMENT.pdf" target="_blank">Margin Disclosure Statement</a> to determine whether a margin account aligns with your investment objectives and risk tolerance.'
                        )
                    }}
                />
                <p>
                    {__(
                        'IPOs involve substantial risk and are not appropriate for every investor. Customers should read the offering prospectus carefully and make their own determination of whether an investment in the offering is consistent with their investment objectives, financial situation, and risk tolerance.'
                    )}
                </p>
                <p>
                    {__(
                        'There are risks associated with short selling, including the risk of unlimited losses and incurrence of margin interest debt. Short selling is not suitable for all investors. Customers should make their own determination of whether a short selling strategy is consistent with their investment objectives, financial situation, and risk tolerance. TradeUP/TradeUP Securities, Inc. does not recommend or endorse the investment of securities that are made available for short sell. Short sell orders can only be placed in a margin account with total account equity of $2000 or above.'
                    )}
                </p>
                <p
                    dangerouslySetInnerHTML={{
                        __html: __(
                            'Options trading entails significant risk and is not appropriate for all investors. Certain complex options strategies carry additional risk. Before trading options, please read <a href="https://www.theocc.com/Company-Information/Documents-and-Archives/Options-Disclosure-Document" target="_blank">Characteristics and Risks of Standardized Options</a>. Supporting documentation for any claims, if applicable, will be furnished upon request.'
                        )
                    }}
                />
                <p>
                    {__(
                        'No content on the website shall be considered a recommendation or solicitation for the purchase or sale of securities, futures or other investment products. All information and data on the website are for reference only and no historical data shall be considered as the basis for judging future trends.'
                    )}
                </p>
                <p>{__('Please read through our Terms and Conditions before investing.')}</p>
                <p
                    dangerouslySetInnerHTML={{
                        __html: __(
                            '<a href="https://static.tradeup.com/files/tradeup-portal/Marsco-Form-CRS.pdf" target="_blank">Customer Relationship Summary</a> | <a href="https://tigerheadline.com/sec606" target="_blank">SEC RULE 606</a> | <a href="https://static.tradeup.com/files/tradeup-portal/Extended%20Hours%20Trading%20Risk%20Disclosure.pdf" target="_blank">Extended Hours Trading Risk Disclosure</a>'
                        )
                    }}
                />
            </div>
        );
    }
}

export default Footer;
